<template>
    <el-table stripe v-loading="loading" ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%"
        :header-cell-style="headCellStyle" :cell-style="bodyCellStyle" :height="tableHeight"
        @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55" />
        <el-table-column :label="$t('user.role')" show-overflow-tooltip prop="name">
            <template #default="{ row }">
                <span>{{ row.name }}</span>
            </template>
        </el-table-column>
        <el-table-column :label="$t('public.table_scope')" v-if="$store.state.type === 3 || $store.state.type === 2"
            show-overflow-tooltip prop="customerName" />
        <el-table-column :label="$t('user.remarks')" show-overflow-tooltip prop="remark" />
        <el-table-column :label="$t('public.table_operation')" prop="operate" width="140px">
            <template #default="{ row }">
                <el-button type="text" icon="el-icon-tickets" size="small" :title="$t('public.details')"
                    @click="detailFn(row)">
                </el-button>
                <el-button type="text" icon="el-icon-delete" size="small" :title="$t('public.btn_delete')"
                    @click="delFn(row)">
                </el-button>
            </template>
        </el-table-column>
    </el-table>
</template>

<script>
export default {
  props: ['loading', 'tableData'],
  data () {
    return {
      tableHeight: 'calc(100% - 60px)'
    }
  },
  methods: {
    handleSelectionChange (arg) {
      this.$emit('choozeTableFn', arg)
    },
    detailFn (row) {
      this.$emit('detailFn', row)
    },
    delFn (row) {
      this.$emit('delFn', row)
    }

  }

}
</script>

<style></style>
